import UserService from '../services/UserService'

const RenderOnAuthenticated = ({ children }) => (UserService.isLoggedIn() ? children : null)

export default RenderOnAuthenticated
